import React, { Component } from 'react';

/**
 * An HOC for adding a property with a ref to a scrollable container DOM element
 * @param InnerComponent - The inner component to pass the the ref to
 * @param classNameSelector - The class name of the container in order to select it from the DOM
 * @return {WithScrollableContainerRef}
 */
export default (InnerComponent, classNameSelector) => {
  /**
   * A component that adds the container ref as a property to the component
   */
  class WithScrollableContainerRef extends Component {
    /**
     * componentDidMount
     */
    componentDidMount() {
      const result = document.getElementsByClassName(classNameSelector);
      this.scrollableContainer = result.length > 0 ? result[0] : null;
      // Force update is necessary since on first render the DOM element is not available
      this.forceUpdate();
    }

    /**
     * render
     * @return {XML}
     */
    render() {
      return <InnerComponent {...this.props} scrollableContainer={this.scrollableContainer} />;
    }
  }

  WithScrollableContainerRef.propTypes = {
    ...InnerComponent.propTypes
  };

  return WithScrollableContainerRef;
};
